import { useState } from 'react'
import dayjs from 'dayjs'
import { Button, Heading } from '@boltenergy-be/design-system'
import classNames from 'classnames'
import PageLayout from 'layouts/page-layout/PageLayout.tsx'
import styles from './Dashboard.module.scss'
import { useStoreDispatch, useStoreSelector } from 'hooks/store.ts'
import ProspectReports from './sections/ProspectReports.tsx'
import { ROLES } from '@boltenergy-be/shared'
import { Navigate } from 'react-router'
import { routes } from 'types/routes.ts'
import BillingDetailsReports from './sections/BillingDetailsReports.tsx'
import ServiceContractReports from './sections/ServiceContractReports.tsx'
import { boltBackend } from 'store/queries/bolt-backend'
import { BOLT_BACKEND_TAGS } from 'store/queries/bolt-backend/constants.ts'

const Dashboard = () => {
  // Redux
  const { firstName, role } = useStoreSelector((store) => store.sales)
  const dispatch = useStoreDispatch()

  // Local state
  const [lastRefresh, setLastRefresh] = useState(() => dayjs())

  /**
   * Invalidates the cached sales reports so every section re-fetches its data
   */
  const handleRefresh = () => {
    dispatch(boltBackend.util.invalidateTags([BOLT_BACKEND_TAGS.salesReports]))
    setLastRefresh(dayjs())
  }

  if (role !== ROLES.salesManager && role !== ROLES.salesTeamLead) {
    return <Navigate to={routes.SALES_HOME} replace />
  }

  return (
    <PageLayout
      seoTitle="Dashboard"
      title={
        <div className={styles.header}>
          <Heading as="h1" variant="h2">
            Hey {firstName}
          </Heading>
          <div>
            <small>
              Last refresh on:
              <br />
              <time dateTime={lastRefresh.toISOString()}>{lastRefresh.format('DD/MM/YYYY - HH:mm')}</time>
            </small>
            <Button onClick={handleRefresh} trailingIcon="refresh" variant="secondary">
              Refresh
            </Button>
          </div>
        </div>
      }
    >
      {/* Opportunities & to be confirmed */}
      <section className={classNames(styles.section, styles.opportunities)}>
        <ProspectReports />
      </section>

      {/* Serviced contracts overview */}
      <section className={classNames(styles.section, styles.overview)}>
        <ServiceContractReports />
      </section>

      {/* Serviced contracts: extra information */}
      <section className={classNames(styles.section, styles['billing-details'])}>
        <BillingDetailsReports />
      </section>
    </PageLayout>
  )
}

export default Dashboard
